import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, ExternalLink } from 'lucide-react';
import './Blog.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${BACKEND_URL}/api/articles`);
      if (!response.ok) throw new Error('Failed to fetch articles');
      
      const data = await response.json();
      setArticles(data.articles || []);
      setError(null);
    } catch (err) {
      console.error('Error fetching articles:', err);
      setError('Failed to load articles. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="blog-page">
      <section className="page-hero">
        <h1 className="display-huge">Blog & Insights</h1>
        <p className="body-large" style={{ marginTop: '32px', maxWidth: '800px', margin: '32px auto 0' }}>
          Latest thinking on AI, automation, and the future of enterprise support.
        </p>
      </section>

      <section className="blog-section">
        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p className="body-large">Loading latest AI insights...</p>
          </div>
        ) : error ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <p className="body-large" style={{ color: 'var(--error-color, #ff6b6b)' }}>{error}</p>
          </div>
        ) : (
          <div className="blog-grid">
            {articles.map((post, index) => (
              <article key={index} className="blog-card dark-hover">
                {post.image && (
                  <div 
                    className="blog-image" 
                    style={{ 
                      backgroundImage: `url(${post.image})`,
                      height: '200px',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      borderRadius: '8px 8px 0 0',
                      backgroundColor: '#1a1a1a'
                    }}
                  ></div>
                )}
                <div style={{ padding: '24px' }}>
                  <div className="blog-meta">
                    <span className="category">{post.category || 'AI Insights'}</span>
                    {post.date && (
                      <span className="date">
                        {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </span>
                    )}
                  </div>
                  <h2 className="heading-2" style={{ marginTop: '20px' }}>{post.title}</h2>
                  <p className="body-medium" style={{ marginTop: '16px' }}>{post.excerpt}</p>
                  <div className="blog-footer" style={{ marginTop: '24px' }}>
                    <a 
                      href={post.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="read-more"
                      style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}
                    >
                      Read More <ExternalLink size={16} />
                    </a>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}

        <div className="coming-soon">
          <h3 className="heading-1">Fresh AI insights updated weekly</h3>
          <p className="body-medium" style={{ marginTop: '16px' }}>
            Articles automatically updated from The AI Journal to bring you the latest in AI trends and innovations.
          </p>
          <Link to="/demo" className="btn-primary" style={{ marginTop: '32px' }}>
            Schedule a Consultation
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Blog;